import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import moment from "moment";
import { Spin } from "antd";
import { GetTNCVersionApi } from "../../../api/request/client";
import { useParams } from "react-router-dom";

const ViewTNC = () => {
    const { version } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const getTNC = async () => {
        setLoading(true);
        try {
            const { data } = await GetTNCVersionApi(version);
            if (data?.success) {
                setData(data?.data[0]);
            }
        } catch (error) {
            toast.error('Failed to load terms & contion');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { getTNC() }, [version]);

    if (loading) return <p className="flex items-center justify-center min-h-screen"><Spin size="large" /></p>;

    return (
        <>
            <div className="min-h-screen bg-[#111827] flex flex-col  items-center p-4">
                <div className="max-w-4xl w-full bg-white rounded-lg shadow-lg overflow-hidden">
                    {data ? (
                        <>
                            {/* Header Section */}
                            <div className="bg-[#1F2937] text-white p-6">
                                <h1 className="text-2xl font-bold mb-4">Version {data?.version}</h1>
                                <div className="flex flex-wrap gap-4 text-sm text-gray-300">
                                    <div className="flex items-center gap-2">
                                        <span className="inline-block w-2 h-2 bg-gray-400 rounded-full"></span>
                                        <span>Version: {data?.version}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <span className="inline-block w-2 h-2 bg-gray-400 rounded-full"></span>
                                        <span>Effective: {moment(data?.effectiveDate).format("MMMM DD, YYYY, h:mm A")}</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <span className="inline-block w-2 h-2 bg-gray-400 rounded-full"></span>
                                        <span>Updated: {moment(data?.lastModifiedDate).format("M/D/YY, h:mm A")}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Content Section */}
                            <div className="p-8">
                                <div
                                    className="text-gray-700 leading-relaxed text-justify"
                                    dangerouslySetInnerHTML={{ __html: data?.content }}
                                />
                            </div>

                            {/* Footer Section */}
                            <div className="bg-gray-50 px-8 py-4 flex justify-between items-center text-sm text-gray-500 border-t">
                                <div>© 2025 Upforex. All rights reserved.</div>
                                <div>Document generated on {moment(data?.createdDate).format("M/D/YY, h:mm A")}</div>
                            </div>
                        </>
                    ) : (
                        <div className="p-8 text-center">
                            <p className="text-gray-600">No Terms and Conditions available.</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ViewTNC;
